export default {"src":"/_next/static/media/threat-actor-profiling.b7b7eb9b.svg","height":810,"width":810,"blurWidth":0,"blurHeight":0};